function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237.812,
    height: 237.812,
    viewBox: "0 0 62.921 62.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 31.46,
    cy: 31.461,
    r: 29.721,
    style: {
      stroke: "var(--primary)",
      strokeWidth: 3.479,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.46,
    cy: 31.461,
    r: 23.717,
    style: {
      fill: "var(--primary-dark)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.46086,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.df801bd3e571756e25b5542196241eb7.svg";
export { ForwardRef as ReactComponent };